import { render, staticRenderFns } from "./NoProduct.vue?vue&type=template&id=5fe0c132&scoped=true&"
import script from "./NoProduct.vue?vue&type=script&lang=js&"
export * from "./NoProduct.vue?vue&type=script&lang=js&"
import style0 from "./NoProduct.vue?vue&type=style&index=0&id=5fe0c132&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe0c132",
  null
  
)

export default component.exports